export const isJefeMedico = () => {

  const codigos = ['003', '0000000001'];

  const userLoginLS = localStorage.getItem('detalleusuario');
  const userLoginDetails = JSON.parse(userLoginLS);

  if(!userLoginDetails) return false;

  return userLoginDetails?.roles.some( role => codigos.includes(role.codigo) );

}